module.exports = __webpack_public_path__ + "static/media/Michael_Jordan.218dbc7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Michael_Jordan.jpg
// module id = 412
// module chunks = 0